import { Avatar, Button, Card, Container, Divider, Grid, Hidden, makeStyles, Paper, Typography } from "@material-ui/core";
import { CheckCircle, EmojiEvents, Person, SentimentDissatisfied, SentimentVeryDissatisfied } from "@material-ui/icons";
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { LogNumberCard } from "./LogNumberCard";
//import Confetti from "react-confetti";

import * as ROUTES from "../../constants/routes";
import { useTranslation } from "react-i18next";
import { green, grey, orange, red } from "@material-ui/core/colors";
import CountUp from "react-countup";
import Footer from "../Footer";
import Fireworks from "../Fireworks";

export const EvaluationResult = ({ attemp, course, hitRatio, userInfo, isReviewed }) => {
  const history = useHistory();
  const styles = useStyles();
  const { t } = useTranslation();

  let questinOrdered = [];
  let loaded = false;
  const correct = !!attemp?.metadata?.correct ? attemp?.metadata?.correct : 0;
  const wrong = !!attemp?.metadata?.wrong ? attemp?.metadata?.wrong : 0;
  let correctRatio = correct / (correct + wrong);

  Object.keys(attemp.data).map((response) => {
    questinOrdered[response.split("question")[1]] = attemp.data[response];
  }, (loaded = true));

  const courseId = { ECS1: "FCSReconocimientoPrecoz", ECS2: "FCSRCPPrecoz", ECS3: "FCSDesfibrilacionPrecoz" };

  return (
    <Grid container justify="center" style={{ background: `linear-gradient( #9933CC 0 25vh, transparent 25vh 100%)`, minHeight: "100vh" }}>
      {correctRatio === hitRatio && !isReviewed && <Fireworks time={5000} />}
      <Grid item xs={12} lg={9}>
        <Paper className={styles.mainCard} elevation={5}>
          <Grid container alignItems="center" spacing={3}>
            <Grid item xs={12} md={2} container justify="center">
              <Avatar className={styles.mainIcon} style={{ marginRight: 16, height: 86, width: 86, backgroundColor: correctRatio >= hitRatio ? green[500] : red[500] }}>
                {correctRatio == hitRatio ? <EmojiEvents style={{ fontSize: 48 }} /> : <SentimentVeryDissatisfied style={{ fontSize: 54 }} />}
              </Avatar>
            </Grid>
            <Grid item xs={12} md={10}>
              <Typography variant="h1" className={styles.mainTitle} style={{ color: correctRatio >= hitRatio ? green[500] : red[500] }}>
                {correctRatio == hitRatio ? t("has_superado_la_evaluación_del_módulo") : t("evaluationNotPassed")}
              </Typography>
              <Typography variant="h1" className={styles.subtitle}>
                {userInfo?.sgpfc?.rescuer ? t("¡Genial!_has_completado_todos_los_módulos") : t("Completa_todas_las_evaluaciones_para_ser_miembro_activo_de_la_comunidad")}
              </Typography>
            </Grid>
            <Grid item xs={12} container justify="center">
              <Grid item xs={4} md={2} container direction="column" justify="center" alignItems="center">
                <Avatar style={{ height: 72, width: 72, backgroundColor: grey[100] }}>
                  <Typography variant="h5" style={{ fontWeight: "500", fontSize: 42, color: green[500] }}>
                    <CountUp end={correct} duration={0.75} />
                  </Typography>
                </Avatar>
                <Typography className={styles.mainSubtitle}> {t("aciertos")}</Typography>
              </Grid>
              <Grid item xs={4} md={2} container direction="column" justify="center" alignItems="center">
                <Avatar style={{ height: 72, width: 72, backgroundColor: grey[100] }}>
                  <Typography variant="h5" style={{ fontWeight: "500", fontSize: 42, color: orange[500] }}>
                    <CountUp end={wrong} duration={0.75} />
                  </Typography>
                </Avatar>
                <Typography className={styles.mainSubtitle}> {t("fallos")}</Typography>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
        <Grid container>
          {loaded &&
            questinOrdered.map((q, index) => (
              <Grid item xs={12}>
                <Paper variant="outlined" className={styles.questionCard}>
                  <Grid justify="center" container>
                    <Grid item xs={12}>
                      <Typography variant="h6" color="primary">
                        {t("question", { index: index + 1 })}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} style={{ marginBottom: 12 }}>
                      <Typography variant="subtitle1">{t(q.question)}</Typography>
                    </Grid>
                    <Grid item xs={12} container spacing={1} alignItems="center" direction="row" style={{ marginBottom: 1 }}>
                      <Grid item xs={1} container justify="flex-end">
                        <CheckCircle
                          style={{
                            fontSize: 16,
                            color: "green",
                            marginRight: 8,
                          }}
                        />
                      </Grid>
                      <Grid item xs={11}>
                        <Typography>{t(q.correctAnswer)}</Typography>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} container spacing={1} alignItems="center" direction="row">
                      <Grid item xs={1} container justify="flex-end">
                        <Person
                          style={{
                            fontSize: 16,
                            color: "grey",
                            marginRight: 8,
                          }}
                        />
                      </Grid>
                      <Grid item xs={11}>
                        <Typography
                          style={{
                            color: q.userAnswer === q.correctAnswer ? "green" : "red",
                          }}
                        >
                          {t(q.userAnswer)}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            ))}
        </Grid>
      </Grid>
      <Grid container item xs={12} lg={9} justify="flex-end" className={styles.homeButton}>
        <Button
          variant="outlined"
          color="primary"
          style={{ textTransform: "none" }}
          onClick={() => {
            window.scrollTo({ top: 0, behavior: "auto" });
            history.push(ROUTES.MODULE.replace(":id", courseId[course]));
          }}
        >
          {t("volver_al_modulo")}
        </Button>
      </Grid>
      <Footer />
    </Grid>
  );
};

const useStyles = makeStyles((theme) => ({
  mainCard: {
    transition: "all 0.5s ease-out",
    [theme.breakpoints.up("md")]: {
      marginTop: "10vh",
      paddingTop: 32,
      padding: 18,
      borderRadius: 9,
    },
    [theme.breakpoints.down("md")]: {
      marginTop: "12vh",
      padding: 18,
      borderRadius: "16px 16px 0px 0px",
      boxShadow: "0px 0px",
    },
  },
  mainIcon: {
    [theme.breakpoints.down("md")]: {
      marginTop: -43 - 16,
      boxShadow: "0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)",
    },
  },
  mainTitle: {
    letterSpacing: 0,
    color: "#3c4043",

    marginBottom: 8,
    [theme.breakpoints.up("md")]: {
      font: "400 32px/40px Google Sans,Arial,sans-serif",
    },
    [theme.breakpoints.down("md")]: {
      font: "400 30px/40px Google Sans,Arial,sans-serif",
    },
  },
  mainSubtitle: {
    animation: "fade-down .8s ease .3s 1 normal both running",
    color: "#9aa0a6",
    font: "400 18px/20px Google Sans,Arial,sans-serif",
    marginTop: 9,
  },
  homeButton: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(8),
    [theme.breakpoints.down("md")]: {
      marginRight: 18,
    },
  },
  questionCard: {
    padding: 16,
    borderRadius: 0,
    [theme.breakpoints.up("md")]: {
      marginTop: theme.spacing(3),
      borderRadius: 9,
    },
  },
  subtitle: {
    animation: "fade-down .8s ease .3s 1 normal both running",
    color: "#9aa0a6",
    font: "400 16px/26px Google Sans,Arial,sans-serif",
    [theme.breakpoints.up("md")]: {
      maxWidth: "80%",
    },
  },
}));
